import React from 'react';
import { Typography, Link as MuiLink, TypographyProps } from '@mui/material';
import { AvailableTranslation } from '@lialo/core/lib/models';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import routes from '@lialo/core/lib/pages/utils/routes';
import { useServiceProvider } from '../../../../common/Providers';

interface Props {
  tourCode: string;
  availableTranslations: AvailableTranslation[];
}

export const LanguageSelect = ({ tourCode, availableTranslations }: Props) => {
  const { t } = useTranslation();
  const { navigationService } = useServiceProvider();

  const links = availableTranslations
    .sortBy('language', 'ASC', (a, b) => t(`common.native_languages.${a}`).localeCompare(t(`common.native_languages.${b}`)))
    .map(it => {
      return it.shortLink === tourCode ? (
        <Typography sx={{ fontWeight: 500 }} key={it.language} component={'span'}>
          {t(`common.native_languages.${it.language}`)}
        </Typography>
      ) : (
        <MuiLink
          component={Link}
          key={it.language}
          to={routes.createLocationDescriptorObject(navigationService.generateTourDetailUrl(it.shortLink), {
            canGoBack: true,
          })}
        >
          {t(`common.native_languages.${it.language}`)}
        </MuiLink>
      );
    });

  // Add comma between every array item
  return (
    <>
      {links
        .flatMap((link: React.ReactElement): JSX.Element[] => [
          link,
          React.createElement(Typography, {
            children: ', ',
            component: 'span',
            key: link.key + 'comma',
          } as TypographyProps),
        ])
        .slice(0, -1)}
    </>
  );
};
